const { getTranslationDictionary } = require('core');

//Type = EventCodes found in Timpex.Traffic.Bal, ByPackage.ByPackageEvent.EventCodes
module.exports = function extractPackageEventText(type, isActual) {
	const translationDictionary = getTranslationDictionary();
	const packageType = 'package' + type;
	const propertyName = `${packageType}${isActual ? 'Actual' : ''}Event`;
	return translationDictionary[propertyName];
};
